"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var clsx_1 = __importDefault(require("clsx"));
var utils_1 = require("@prezzee/utils");
var style = __importStar(require("./ButtonBase.style"));
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */
var ButtonBase = (0, react_1.forwardRef)(function (props, ref) {
    var action = props.action, children = props.children, className = props.className, _a = props.component, component = _a === void 0 ? 'button' : _a, 
    // @ts-ignore
    css = props.css, _b = props.disabled, disabled = _b === void 0 ? false : _b, focusVisibleClassName = props.focusVisibleClassName, _c = props.LinkComponent, LinkComponent = _c === void 0 ? 'a' : _c, onBlur = props.onBlur, onClick = props.onClick, onContextMenu = props.onContextMenu, onDragLeave = props.onDragLeave, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, _d = props.tabIndex, tabIndex = _d === void 0 ? 0 : _d, type = props.type, other = __rest(props, ["action", "children", "className", "component", "css", "disabled", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "type"]);
    var buttonRef = (0, react_1.useRef)(null);
    var _e = (0, utils_1.useIsFocusVisible)(), isFocusVisibleRef = _e.isFocusVisibleRef, handleFocusVisible = _e.onFocus, handleBlurVisible = _e.onBlur, focusVisibleRef = _e.ref;
    var _f = __read((0, react_1.useState)(false), 2), focusVisible = _f[0], setFocusVisible = _f[1];
    if (disabled && focusVisible) {
        setFocusVisible(false);
    }
    (0, react_1.useImperativeHandle)(action, function () { return ({
        focusVisible: function () {
            setFocusVisible(true);
            buttonRef.current.focus();
        },
    }); }, []);
    var handleMouseDown = onMouseDown;
    var handleContextMenu = onContextMenu;
    var handleDragLeave = onDragLeave;
    var handleMouseUp = onMouseUp;
    var handleMouseLeave = function (event) {
        if (focusVisible) {
            event.preventDefault();
        }
        if (onMouseLeave) {
            onMouseLeave(event);
        }
    };
    var handleTouchStart = onTouchStart;
    var handleTouchEnd = onTouchEnd;
    var handleTouchMove = onTouchMove;
    var handleBlur = function (event) {
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setFocusVisible(false);
        }
        if (onBlur) {
            onBlur(event);
        }
    };
    var handleFocus = (0, utils_1.useEventCallback)(function (event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) {
            buttonRef.current = event.currentTarget;
        }
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) {
                onFocusVisible(event);
            }
        }
        if (onFocus) {
            onFocus(event);
        }
    });
    var isNonNativeButton = function () {
        var button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
     * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
     */
    var keydownRef = (0, react_1.useRef)(false);
    var handleKeyDown = (0, utils_1.useEventCallback)(function (event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (!keydownRef.current && focusVisible && event.key === ' ') {
            keydownRef.current = true;
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
            event.preventDefault();
        }
        if (onKeyDown) {
            onKeyDown(event);
        }
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget &&
            isNonNativeButton() &&
            event.key === 'Enter' &&
            !disabled) {
            event.preventDefault();
            if (onClick) {
                onClick(event);
            }
        }
    });
    var handleKeyUp = (0, utils_1.useEventCallback)(function (event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (event.key === ' ' && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
        }
        if (onKeyUp) {
            onKeyUp(event);
        }
        // Keyboard accessibility for non interactive elements
        if (onClick &&
            event.target === event.currentTarget &&
            isNonNativeButton() &&
            event.key === ' ' &&
            !event.defaultPrevented) {
            onClick(event);
        }
    });
    var ComponentProp = component;
    // @ts-ignore
    if (ComponentProp === 'button' && (other.href || other.to)) {
        ComponentProp = LinkComponent;
    }
    var buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    }
    else {
        // @ts-ignore
        if (!other.href && !other.to) {
            buttonProps.role = 'button';
        }
        if (disabled) {
            buttonProps['aria-disabled'] = disabled;
        }
    }
    var handleOwnRef = (0, utils_1.useForkRef)(focusVisibleRef, buttonRef);
    var handleRef = (0, utils_1.useForkRef)(ref, handleOwnRef);
    var ButtonBaseRoot = ComponentProp;
    return ((0, jsx_runtime_1.jsx)(ButtonBaseRoot, __assign({ css: [style.root, css && css], className: (0, clsx_1.default)([className, focusVisible && focusVisibleClassName && focusVisibleClassName]), onBlur: handleBlur, onClick: onClick, onContextMenu: handleContextMenu, onFocus: handleFocus, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp, onMouseDown: handleMouseDown, onMouseLeave: handleMouseLeave, onMouseUp: handleMouseUp, onDragLeave: handleDragLeave, onTouchEnd: handleTouchEnd, onTouchMove: handleTouchMove, onTouchStart: handleTouchStart, ref: handleRef, tabIndex: disabled ? -1 : tabIndex, type: type }, buttonProps, other, { children: children })));
});
exports.default = ButtonBase;
//# sourceMappingURL=ButtonBase.js.map